import { useMemo } from "react";

import { getBenchmarkItems } from "../utils/fluencyWpm/stems";

/**
 * Catalog of fluency benchmark items for grade × subject (ELA 1st–3rd).
 * Persistence is via content_student_comment.customData.readingFluency.
 */
const useFluencyWpm = ({ gradeName, subjectName }) => {
    const items = useMemo(() => getBenchmarkItems(gradeName, subjectName), [gradeName, subjectName]);
    return { eligible: items.length > 0, items };
};

export default useFluencyWpm;
